import { initialLocale, SiteCountry } from '../locale'
import { initialTotmTraveler, TotmTraveler } from '../totm/interrail/totmOrder'

export enum TravelerType {
  Adult,
  Child,
}

export interface ICar {
  LicensePlate?: string
  WinterTyres?: boolean
}

export interface Traveler {
  Id: number
  Type: TravelerType
  MainTraveler: boolean
  Gender: 'Male' | 'Female'
  Forename?: string
  Middlename?: string
  LastName?: string
  KnownAs?: string
  DateOfBirth?: Date
  Country: SiteCountry
  PostCode?: string
  Housenumber?: string
  Flatnumber?: string
  Street?: string
  City?: string
  Email?: string
  Telephonenumber?: string
  AddressLine2?: string
  DoNotNotify?: boolean
  TotmTraveler: TotmTraveler
  Car?: ICar
}

export interface Baby {
  Id: number
  Forename?: string
  Middlename?: string
  LastName?: string
  KnownAs?: string
  Gender?: 'Male' | 'Female'
  DateOfBirth?: Date
}

export const initialTraveler: Traveler = {
  Id: 0,
  Type: TravelerType.Adult,
  MainTraveler: true,
  Gender: 'Male',
  Country: initialLocale.country,
  Street: '',
  City: '',
  DoNotNotify: false,
  TotmTraveler: initialTotmTraveler,
}

export const initialAdult: Traveler = {
  Id: 1,
  Type: TravelerType.Adult,
  MainTraveler: false,
  Gender: 'Male',
  Country: initialLocale.country,
  DoNotNotify: false,
  TotmTraveler: initialTotmTraveler,
}

export const initialChild: Traveler = {
  Id: 2,
  Type: TravelerType.Child,
  MainTraveler: false,
  Gender: 'Male',
  Country: initialLocale.country,
  TotmTraveler: initialTotmTraveler,
}
